import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import './OAuth.scss';
import { connect } from 'react-redux';
import { microsoftLogin } from 'redux/ducks/Session';
import { ORGANIZATION_TYPES_REGISTRATION } from 'helpers/enums';
import {
  loadGoogleAdsFromLocalStorage,
  loadOrganizationDetailsFromLocalStorage,
  getReferralCode,
} from '@helpers/localStorage';
import { withRouter } from 'react-router-dom';

const Microsoft = ({ microsoftLogin, history, step }) => {
  // Microsoft OAuth configuration
  const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: process.env.REACT_APP_FRONTEND_DOMAIN || 'http://localhost:4000',
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };

  const loginRequest = {
    scopes: ['User.Read'],
    prompt: 'select_account',
  };

  const handleMicrosoftLogin = async () => {
    try {
      const msalInstance = new PublicClientApplication(msalConfig);

      await msalInstance.initialize();

      const response = await msalInstance.loginPopup(loginRequest);
      const credentials = {
        ...response,
        user_data: {
          default_event_setting_id:
            ORGANIZATION_TYPES_REGISTRATION[localStorage.getItem('registrationOrgType')],
          ...loadGoogleAdsFromLocalStorage(),
          ...loadOrganizationDetailsFromLocalStorage(),
          ...(getReferralCode() && { referral: getReferralCode() }),
        },
      };

      microsoftLogin(credentials, history, step);
    } catch (error) {
      console.error('Microsoft login error:', error);
      // onError(error);
    }
  };

  return (
    <div className="microsoft-login">
      <button type="button" className="microsoft-login-button" onClick={handleMicrosoftLogin}>
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.5 1H1V9.5H9.5V1Z" fill="#F25022" />
          <path d="M19 1H10.5V9.5H19V1Z" fill="#7FBA00" />
          <path d="M9.5 10.5H1V19H9.5V10.5Z" fill="#00A4EF" />
          <path d="M19 10.5H10.5V19H19V10.5Z" fill="#FFB900" />
        </svg>
        <span>Sign in with Microsoft</span>
      </button>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  microsoftLogin: (credentials, history, step) => dispatch(microsoftLogin({ credentials, history, step })),
});

export default withRouter(connect(null, mapDispatchToProps)(Microsoft));
